import * as React from 'react'
import PropTypes from 'prop-types'

function SuccessScreenCollage({ width, height }) {
  return (
    <svg
      viewBox="0 0 162 242"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M151.125 191.301c8.505 4.598 8.505 12.1.121 16.698l-54.918 30.008c-8.505 4.598-22.234 4.598-30.74 0l-55.282-30.008c-8.505-4.598-8.505-12.1-.121-16.698l54.918-30.008c8.505-4.598 22.234-4.598 30.74 0l55.282 30.008z"
        fill="url(#prefix__paint0_linear)"
        opacity={0.2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153.919 187.913v1.21c0 .121 0 .242-.122.242-.121 0 0 .121-.121.242a.423.423 0 01-.122.242c0 .121-.121.121-.121.242s-.122.242-.122.363-.121.121-.121.242-.122.242-.122.363-.121.121-.121.242-.122.242-.243.363c-.122.121-.122.121-.122.242s-.243.242-.243.363l-.121.121c-.122.242-.365.363-.486.605l-.122.121c-.121.121-.243.363-.486.484l-.243.242c-.121.121-.243.121-.243.242s-.243.121-.243.242-.243.121-.364.242c-.122.121-.243.121-.365.242-.121.121-.243.121-.364.242-.122.121-.243.121-.365.242-.121.121-.243.121-.364.242a.925.925 0 01-.486.242l-51.832 30.008c-.486.242-.85.484-1.336.726-.122 0-.243.121-.365.121-.486.242-.85.363-1.336.605a.121.121 0 00-.122.121 6.869 6.869 0 01-1.458.484c-.35.138-.718.22-1.093.242a7.615 7.615 0 01-.85.242c-.365.121-.73.121-1.094.242-.365.121-.608.121-.85.121h-.365c-.486.121-.972.121-1.458.242h-.365a2.086 2.086 0 00-.85.121c-.486 0-.972.121-1.337.121h-4.01a2.667 2.667 0 01-.971-.121c-.365 0-.73-.121-.972-.121-.243 0-.608-.121-.972-.121a3.54 3.54 0 01-1.094-.242c-.243 0-.607-.121-.85-.121-.486-.121-.85-.242-1.215-.363-.365-.121-.608-.121-.85-.242-.244-.121-.244-.121-.487-.121a5.063 5.063 0 01-1.215-.484c-.121 0-.243-.121-.364-.121a4.329 4.329 0 01-1.094-.484c-.121-.121-.364-.121-.486-.242l-1.458-.726-52.245-30.008c-4.01-2.299-6.075-5.324-6.075-8.47v5.566c0 3.025 2.066 6.05 6.075 8.47l52.245 30.008 1.458.726c.122.121.365.121.486.242.365.121.608.242.972.363h.122c.121 0 .243.121.364.121.424.108.833.271 1.215.484.122 0 .243.121.486.121a.426.426 0 01.243.121c.122 0 .365.121.486.121.365.121.85.242 1.215.363a.45.45 0 01.365.121.733.733 0 01.486.121c.364.121.729.121 1.093.242a.928.928 0 01.486.121h.486c.365 0 .73.121.972.121h4.982c.449.026.899-.015 1.336-.121h1.215a6.109 6.109 0 001.458-.242h.486c.205-.028.408-.069.608-.121.364-.121.729-.121 1.093-.242.279-.097.563-.178.85-.242a3.54 3.54 0 011.094-.242c.122 0 .122 0 .243-.121a5.066 5.066 0 001.215-.484.121.121 0 00.122-.121 6.546 6.546 0 001.336-.605c.122 0 .243-.121.365-.121.459-.216.905-.459 1.336-.726l51.881-30.008c.121 0 .121-.121.243-.121.121 0 .121-.121.243-.121.121 0 .243-.121.364-.242.122-.121.243-.121.365-.242.121-.121.243-.121.364-.242.122-.121.243-.121.365-.242.121-.121.243-.121.364-.242.122-.121.243-.121.243-.242s.243-.121.243-.242l.122-.121.121-.121.486-.484.122-.121c.197-.17.362-.375.486-.605l.121-.121c.122-.121.243-.242.243-.363s.122-.121.122-.242.121-.242.243-.363l.242-.242c0-.121.122-.242.122-.363s.121-.121.121-.242.122-.242.122-.363v-.242a.421.421 0 01.121-.242c0-.121 0-.121.122-.242.121-.121 0-.242.121-.242v-7.018c.195.121.195.242.195.363z"
        fill="url(#prefix__paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M147.966 179.08c8.019 4.598 8.14 12.1.121 16.698l-51.832 30.008c-8.019 4.598-21.02 4.598-29.038 0l-52.245-30.008c-8.02-4.598-8.14-12.1-.122-16.698l51.88-30.008c8.02-4.598 21.02-4.598 29.04 0l52.196 30.008z"
        fill="url(#prefix__paint2_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.133 186.461c-.972 4.356-4.374 8.47-10.085 11.858-13.972 8.107-36.571 8.107-50.665 0-5.832-3.388-9.234-7.623-10.206-11.979-1.458-6.171 1.944-12.584 10.084-17.303 13.973-8.107 36.693-8.107 50.666 0 8.262 4.719 11.664 11.253 10.206 17.424z"
        fill="url(#prefix__paint3_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.133 186.461c-.972 4.356-4.374 8.47-10.085 11.858-13.972 8.107-36.571 8.107-50.665 0-5.832-3.388-9.234-7.623-10.206-11.979.972-4.356 4.374-8.47 10.084-11.858 13.973-8.107 36.693-8.107 50.666 0 5.832 3.388 9.234 7.623 10.206 11.979z"
        fill="url(#prefix__paint4_linear)"
      />
      <path
        opacity={0.6}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.075 24.684a136.465 136.465 0 01-5.832 39.688 137.868 137.868 0 01-16.888 36.421l-4.374 6.655a45.004 45.004 0 01-10.328-5.687 44.183 44.183 0 01-9.355-9.68 41.299 41.299 0 01-7.363-23.716V55.781c8.106 1.57 16.315-2.176 20.412-9.317l6.561-11.374a18.112 18.112 0 008.87 2.42 17.529 17.529 0 0014.58-7.623l3.717-5.203z"
        fill="url(#prefix__paint5_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.115 29.887a136.458 136.458 0 01-5.832 39.688 137.87 137.87 0 01-16.888 36.421l-4.374 6.655a45.044 45.044 0 01-10.328-5.687 44.199 44.199 0 01-9.355-9.68 41.3 41.3 0 01-7.412-23.716V60.984c8.106 1.57 16.316-2.177 20.412-9.317L73.9 40.293a18.113 18.113 0 008.87 2.42 17.53 17.53 0 0014.58-7.623l3.766-5.203z"
        fill="url(#prefix__paint6_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.592 34.969l3.523-5.082a146.617 146.617 0 01-5.589 39.446 141.817 141.817 0 01-16.888 36.421l-4.374 6.655a42.58 42.58 0 01-10.328-5.687C53.372 98.846 47.158 86.468 47.17 73.326V60.742c1.2.24 2.421.362 3.645.363a19.334 19.334 0 0016.767-9.559l6.561-11.374a16.906 16.906 0 008.87 2.42 17.687 17.687 0 0014.58-7.623zm2.38-1.865l.001-.071h.049l-.05.071zm0 0l-1.651 2.349a18.709 18.709 0 01-15.43 8.107 19.152 19.152 0 01-8.506-2.057L68.14 52.151a20.27 20.27 0 01-17.496 10.043c-.892.02-1.785-.02-2.673-.121v11.495A40.684 40.684 0 0055.14 96.8a41.96 41.96 0 0018.468 14.762l3.888-6.05a138.097 138.097 0 0016.767-36.179 136.351 136.351 0 005.709-36.229z"
        fill="url(#prefix__paint7_linear)"
        opacity={0.75}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.115 29.887l-3.523 5.082a17.687 17.687 0 01-14.58 7.623 16.905 16.905 0 01-8.87-2.42l-6.56 11.374c-4.134 7.1-12.313 10.834-20.413 9.317v12.584c-.011 13.142 6.203 25.52 16.767 33.396-15.554-6.571-25.65-21.773-25.636-38.599V55.66c8.106 1.57 16.315-2.177 20.412-9.317l6.56-11.374c8.012 4.61 18.237 2.288 23.45-5.324l3.524-5.082 8.869 5.324z"
        fill="url(#prefix__paint8_linear)"
      />
      <path
        opacity={0.6}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.944 83.732s.608-4.84 8.991-10.285a26.288 26.288 0 018.991 10.285s4.544-28.798 17.982-36.179l13.487 7.744c-11.3 4.356-22.721 23.353-30.132 48.279-3.645-9.317-10.328-16.819-19.319-19.844z"
        fill="#6BE726"
      />
      <g opacity={0.95} fillRule="evenodd" clipRule="evenodd">
        <path
          d="M124.395 55.297l-6.804-3.872c-13.487 7.38-17.982 36.179-17.982 36.179a24.208 24.208 0 00-5.954-7.986c1.823-8.228 6.804-26.5 17.253-32.186l13.487 7.865z"
          fill="url(#prefix__paint9_linear)"
        />
        <path
          d="M90.618 77.198l-6.683-3.872c-5.224 3.63-8.14 7.018-8.99 10.285l6.73 3.872a21.262 21.262 0 018.943-10.285z"
          fill="url(#prefix__paint10_linear)"
        />
        <path
          d="M83.085 88.088c4.253 3.267 8.14 7.986 11.178 15.488l6.682 3.872c-3.887-10.043-10.205-15.851-17.86-19.36z"
          fill="url(#prefix__paint11_linear)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.675 87.604s.608-4.84 8.991-10.285a26.291 26.291 0 018.991 10.285s4.496-28.798 17.982-36.179l13.487 7.744c-11.3 4.356-22.721 23.353-30.132 48.279-3.524-9.317-10.376-16.819-19.319-19.844z"
        fill="url(#prefix__paint12_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.609 87.604s4.495-28.798 17.981-36.179l13.608 7.744c-11.299 4.235-22.72 23.353-30.132 48.279-3.645-9.317-10.448-16.819-19.44-19.844 0 0 .608-4.719 8.992-10.285a25.443 25.443 0 018.99 10.285zm30.374-28.556l-12.393-7.139c-11.916 6.83-16.655 31.372-17.393 35.194-.06.31-.093.483-.103.501l-.242 1.573-.73-1.452a24.883 24.883 0 00-8.504-9.922c-6.44 4.356-8.02 8.228-8.384 9.438 8.019 2.904 14.823 9.68 18.711 18.755 7.46-24.321 18.395-42.108 29.038-46.948z"
        fill="url(#prefix__paint13_linear)"
        opacity={0.91}
      />
      <g opacity={0.75} fillRule="evenodd" clipRule="evenodd">
        <path
          opacity={0.9}
          d="M47.12 72.963v.484a42.09 42.09 0 00.73 7.865l28.31 28.193 2.308-3.509.729-1.089L47.12 72.963z"
          fill="url(#prefix__paint14_linear)"
        />
        <path
          opacity={0.9}
          d="M58.59 59.653a19.38 19.38 0 01-11.42 1.331v2.541l35.599 35.453c1.822-3.267 3.645-6.655 5.224-10.043L58.59 59.653z"
          fill="url(#prefix__paint15_linear)"
        />
        <path
          opacity={0.9}
          d="M94.141 72.963c.365-1.089.73-2.299 1.094-3.509.607-2.178 1.215-4.356 1.7-6.534L73.973 40.051l-4.738 8.107L94.14 72.963z"
          fill="url(#prefix__paint16_linear)"
        />
        <path
          opacity={0.9}
          d="M91.711 79.739c.243-.726.486-1.452.729-2.057l-25.515-25.41a8.599 8.599 0 01-1.215 1.694l26.001 25.773z"
          fill="url(#prefix__paint17_linear)"
        />
        <path
          opacity={0.9}
          d="M86.608 42.23l12.271 12.22c.365-2.178.73-4.356.972-6.534l-7.776-7.744a18.783 18.783 0 01-5.467 2.057z"
          fill="url(#prefix__paint18_linear)"
        />
      </g>
      <path
        opacity={0.75}
        d="M38.008 55.781l9.72 5.929"
        stroke="url(#prefix__paint19_linear)"
        strokeWidth={0.8}
      />
      <path
        opacity={0.75}
        d="M64.738 35.574l9.356 5.445"
        stroke="url(#prefix__paint20_linear)"
        strokeWidth={0.8}
      />
      <path
        opacity={0.75}
        d="M91.832 25.29l8.87 5.081"
        stroke="url(#prefix__paint21_linear)"
        strokeWidth={0.8}
      />
      <path
        clipRule="evenodd"
        d="M93.655 2.057l49.329 47.795-16.524 66.55-49.33-47.795 16.525-66.55v0zM77.13 68.607l49.33 47.795L60 135.278 10.67 87.483l66.46-18.876v0z"
        stroke="#B5BDFC"
        strokeWidth={0.28}
      />
      <path
        clipRule="evenodd"
        d="M93.655 2.057L77.13 68.607 10.67 87.483l16.402-66.55L93.655 2.057v0z"
        stroke="#B5BDFC"
        strokeWidth={0.28}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.063 89.661c1.14 0 2.066-.92 2.066-2.057a2.061 2.061 0 00-2.066-2.057c-1.14 0-2.065.921-2.065 2.057s.924 2.057 2.065 2.057zM27.073 22.99c1.141 0 2.066-.921 2.066-2.057a2.061 2.061 0 00-2.066-2.057c-1.14 0-2.065.92-2.065 2.057 0 1.136.925 2.057 2.065 2.057zM76.767 70.301c1.14 0 2.065-.92 2.065-2.057a2.061 2.061 0 00-2.065-2.057c-1.141 0-2.066.921-2.066 2.057s.925 2.057 2.066 2.057zM126.582 118.338c1.14 0 2.065-.921 2.065-2.057a2.061 2.061 0 00-2.065-2.057 2.062 2.062 0 00-2.066 2.057c0 1.136.925 2.057 2.066 2.057zM93.655 4.114c1.141 0 2.066-.92 2.066-2.057A2.061 2.061 0 0093.655 0c-1.14 0-2.065.921-2.065 2.057s.925 2.057 2.065 2.057zM59.756 137.456c1.141 0 2.066-.921 2.066-2.057a2.061 2.061 0 00-2.066-2.057c-1.14 0-2.065.921-2.065 2.057s.925 2.057 2.065 2.057zM143.227 51.909c1.141 0 2.066-.921 2.066-2.057a2.062 2.062 0 00-2.066-2.057 2.06 2.06 0 00-2.065 2.057 2.06 2.06 0 002.065 2.057z"
        fill="#B6BDFC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.804 167.464c0-.605-.324-1.164-.85-1.467a1.705 1.705 0 00-1.702 0c-.526.303-.85.862-.85 1.467a1.68 1.68 0 00.85 1.452l.85 53.24.851-53.24a1.68 1.68 0 00.85-1.452z"
        fill="url(#prefix__paint22_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.178 139.876a2.547 2.547 0 00-2.551-2.541 2.546 2.546 0 00-2.552 2.541 2.419 2.419 0 001.337 2.178l1.263 76.956h-.121l1.215-76.956a2.42 2.42 0 001.41-2.178z"
        fill="url(#prefix__paint23_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.487 160.93c0-.935-.762-1.694-1.701-1.694-.94 0-1.701.759-1.701 1.694a1.68 1.68 0 00.85 1.452l.851 53.24.85-53.24a1.68 1.68 0 00.851-1.452z"
        fill="url(#prefix__paint24_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.031 81.796H24.279l20.533 102.366c.021.691.102 1.38.243 2.057.972 4.356 4.374 8.591 10.206 11.979 14.094 8.107 36.693 8.107 50.666 0 5.71-3.267 9.112-7.502 10.084-11.858.141-.718.223-1.447.243-2.178l20.777-102.366z"
        fill="url(#prefix__paint25_linear)"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear"
          x1={38.5}
          y1={251.5}
          x2={145.5}
          y2={150.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#606060" />
          <stop offset={1} stopColor="#606060" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear"
          x1={8.739}
          y1={234.676}
          x2={153.968}
          y2={234.676}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4870BF" />
          <stop offset={0.25} stopColor="#4A5DC1" />
          <stop offset={0.54} stopColor="#4F6AC8" />
          <stop offset={0.85} stopColor="#586CD4" />
          <stop offset={1} stopColor="#5D79DB" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear"
          x1={232.302}
          y1={256.133}
          x2={232.302}
          y2={82.328}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7CA9FD" />
          <stop offset={0.083} stopColor="#81ADFF" />
          <stop offset={0.41} stopColor="#7CA9FD" />
          <stop offset={0.656} stopColor="#C0D6FF" />
          <stop offset={0.89} stopColor="#C5D9FF" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear"
          x1={119.723}
          y1={-540.991}
          x2={119.723}
          y2={-586.208}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4869BF" />
          <stop offset={0.25} stopColor="#4A6BC1" />
          <stop offset={0.54} stopColor="#4F7FC8" />
          <stop offset={0.85} stopColor="#5864D4" />
          <stop offset={1} stopColor="#5D6ADB" />
        </linearGradient>
        <linearGradient
          id="prefix__paint4_linear"
          x1={15.518}
          y1={-614.801}
          x2={15.518}
          y2={-548.711}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#485BBF" />
          <stop offset={0.25} stopColor="#4A64C1" />
          <stop offset={0.54} stopColor="#4F6AC8" />
          <stop offset={0.85} stopColor="#5864D4" />
          <stop offset={1} stopColor="#5DAEDB" />
        </linearGradient>
        <linearGradient
          id="prefix__paint5_linear"
          x1={65.309}
          y1={124.31}
          x2={125.252}
          y2={88.803}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD13E" />
          <stop offset={0.05} stopColor="#FECD3B" />
          <stop offset={0.31} stopColor="#F8BD32" />
          <stop offset={0.6} stopColor="#F5B42C" />
          <stop offset={1} stopColor="#F4B12A" />
        </linearGradient>
        <linearGradient
          id="prefix__paint6_linear"
          x1={47.06}
          y1={112.474}
          x2={101.018}
          y2={112.474}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A5ADF5" />
          <stop offset={0.19} stopColor="#A0AEF5" />
          <stop offset={0.41} stopColor="#93AEF5" />
          <stop offset={0.64} stopColor="#7C8FF5" />
          <stop offset={0.87} stopColor="#5C87F5" />
          <stop offset={1} stopColor="#4859F5" />
        </linearGradient>
        <linearGradient
          id="prefix__paint7_linear"
          x1={47.06}
          y1={112.409}
          x2={101.006}
          y2={112.409}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.85} />
        </linearGradient>
        <linearGradient
          id="prefix__paint8_linear"
          x1={37.025}
          y1={-421.796}
          x2={96.213}
          y2={-398.854}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4870BF" />
          <stop offset={0.25} stopColor="#4A6BC1" />
          <stop offset={0.54} stopColor="#4F6AC8" />
          <stop offset={0.85} stopColor="#6258D4" />
          <stop offset={1} stopColor="#5D6ADB" />
        </linearGradient>
        <linearGradient
          id="prefix__paint9_linear"
          x1={97.438}
          y1={46.277}
          x2={89.937}
          y2={81.829}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADFBAB" />
          <stop offset={0.22} stopColor="#AAF8A8" />
          <stop offset={0.47} stopColor="#85EB83" />
          <stop offset={0.74} stopColor="#5DC75B" />
          <stop offset={1} stopColor="#45A943" />
        </linearGradient>
        <linearGradient
          id="prefix__paint10_linear"
          x1={76.873}
          y1={72.919}
          x2={75.004}
          y2={85.733}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADFBAB" />
          <stop offset={0.22} stopColor="#AAF8A8" />
          <stop offset={0.47} stopColor="#85EB83" />
          <stop offset={0.74} stopColor="#5DC75B" />
          <stop offset={1} stopColor="#45A943" />
        </linearGradient>
        <linearGradient
          id="prefix__paint11_linear"
          x1={102.87}
          y1={-81.754}
          x2={95.178}
          y2={-98.903}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#67CB65" />
          <stop offset={0.22} stopColor="#78EC76" />
          <stop offset={0.47} stopColor="#86FA84" />
          <stop offset={0.74} stopColor="#83FF81" />
          <stop offset={1} stopColor="#B3FFB1" />
        </linearGradient>
        <linearGradient
          id="prefix__paint12_linear"
          x1={136.455}
          y1={-440.056}
          x2={113.545}
          y2={-488.923}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#71DF6F" />
          <stop offset={0.22} stopColor="#78EC76" />
          <stop offset={0.47} stopColor="#86FA84" />
          <stop offset={0.74} stopColor="#83FF81" />
          <stop offset={1} stopColor="#B3FFB1" />
        </linearGradient>
        <linearGradient
          id="prefix__paint13_linear"
          x1={123.249}
          y1={69.568}
          x2={97.013}
          y2={57.758}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={0.93} stopColor="#fff" stopOpacity={0.79} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.85} />
        </linearGradient>
        <linearGradient
          id="prefix__paint14_linear"
          x1={52.874}
          y1={-484.367}
          x2={26.732}
          y2={-461.721}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.85} />
        </linearGradient>
        <linearGradient
          id="prefix__paint15_linear"
          x1={61.44}
          y1={-472.92}
          x2={39.264}
          y2={-446.037}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.85} />
        </linearGradient>
        <linearGradient
          id="prefix__paint16_linear"
          x1={83.027}
          y1={-458.741}
          x2={56.153}
          y2={-437.325}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.85} />
        </linearGradient>
        <linearGradient
          id="prefix__paint17_linear"
          x1={73.938}
          y1={-463.38}
          x2={50.08}
          y2={-437.963}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.85} />
        </linearGradient>
        <linearGradient
          id="prefix__paint18_linear"
          x1={92.818}
          y1={-447.867}
          x2={67.817}
          y2={-423.684}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.85} />
        </linearGradient>
        <linearGradient
          id="prefix__paint19_linear"
          x1={37.814}
          y1={-432.824}
          x2={47.947}
          y2={-432.824}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.85} />
        </linearGradient>
        <linearGradient
          id="prefix__paint20_linear"
          x1={64.495}
          y1={-412.619}
          x2={74.276}
          y2={-412.619}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.85} />
        </linearGradient>
        <linearGradient
          id="prefix__paint21_linear"
          x1={91.638}
          y1={-402.34}
          x2={100.921}
          y2={-402.34}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.85} />
        </linearGradient>
        <linearGradient
          id="prefix__paint22_linear"
          x1={66.829}
          y1={203.73}
          x2={58.182}
          y2={201.687}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
        </linearGradient>
        <linearGradient
          id="prefix__paint23_linear"
          x1={80.912}
          y1={-582.753}
          x2={67.743}
          y2={-579.441}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
        </linearGradient>
        <linearGradient
          id="prefix__paint24_linear"
          x1={97.323}
          y1={-583.665}
          x2={88.676}
          y2={-581.622}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.01} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
        </linearGradient>
        <linearGradient
          id="prefix__paint25_linear"
          x1={18.985}
          y1={84.361}
          x2={18.985}
          y2={218.344}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A5D3F5" stopOpacity={0.01} />
          <stop offset={0.21} stopColor="#9CB5F5" stopOpacity={0.21} />
          <stop offset={0.55} stopColor="#8496F5" stopOpacity={0.55} />
          <stop offset={0.99} stopColor="#2D6CE4" />
          <stop offset={1} stopColor="#2D6CE4" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default SuccessScreenCollage
SuccessScreenCollage.defaultProps = {
  width: 162,
  height: 244
}

SuccessScreenCollage.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
}
